import dayjs from 'dayjs';
import { DataModel, DataModelBuilder, SerializationContext, SerializedData } from '../dto/data-model.js';
import { MapUtils } from '../../utility/map-utils.js';

export class Secret extends DataModel {
  static readonly TYPE_ID: string = '02f481af5d9b4bd28c575abd6507f99b';

  private constructor(
    public readonly uniqueId: string,
    public readonly value: string,
    public readonly creationDate: dayjs.Dayjs,
  ) {
    super();
  }

  get $typeId(): string {
    return Secret.TYPE_ID;
  }

  static create(args: {
    uniqueId: string,
    value: string,
    creationDate: dayjs.Dayjs,
  }): Secret {
    return new Secret(
        args.uniqueId,
        args.value,
        args.creationDate,
    );
  }

  static fromMap(context: SerializationContext, map: SerializedData): Secret {
    return new Secret(
        MapUtils.get<string>(map, 'uniqueId'),
        MapUtils.get<string>(map, 'value'),
        context.decodeDate(MapUtils.get<number>(map, 'creationDate')),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'uniqueId': this.uniqueId,
      'value': this.value,
      'creationDate': context.encodeDate(this.creationDate),
    };
  }

  clone(): this {
    return new Secret(
        this.uniqueId,
        this.value,
        this.creationDate,
    ) as this;
  }

  isSame(other: this): boolean {
    if(this === other) {
      return true;
    }

    return this.uniqueId === other.uniqueId &&
        this.value === other.value &&
        this.creationDate === other.creationDate;
  }
}

export class SecretBuilder extends DataModelBuilder<Secret> {
  build(context: SerializationContext, map: SerializedData): Secret {
    return Secret.fromMap(context, map);
  }
}
